import React from 'react'
import { Fragment } from 'react'
import { StyledStrong } from '../../../components/Common/Amount'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { ReportsApi } from '../../../api/Corporates/Reports'
import CustomTable from '../../../elements/Table/CustomTable'

Order.propTypes = {}

function Order() {
  const { list, fetch, fetching } = useFetchList(ReportsApi.quotations)
  const columns = [
    {
      Header: <strong>Order</strong>,
      accessor: 'order',
    },
    {
      Header: <strong>Description</strong>,
      accessor: 'description',
    },
    {
      Header: <strong>Quotation Value</strong>,
      accessor: 'quotationValue',
    },
    {
      Header: <strong>Estimated Gross Profit</strong>,
      accessor: 'estimatedGrossProfit',
    },
    {
      Header: <strong>Estimated Margin %</strong>,
      accessor: 'estimatedMargin',
    },
    {
      Header: <strong>Order Value</strong>,
      accessor: 'orderValue',
    },
    {
      Header: <strong>Actual Gross Profit</strong>,
      accessor: 'actualGrossProfit',
    },
    {
      Header: <strong>Actual Margin %</strong>,
      accessor: 'actualMargin',
    },
  ]

  return (
    <CustomTable
      CreateButton={() => (
        <Fragment>
          <StyledStrong>Consolidated Orders Report (USD)</StyledStrong>
        </Fragment>
      )}
      fetch={fetch}
      isFilterable={true}
      fetching={fetching}
      defaultPageSize={50}
      columns={columns}
      data={list}
      rowKey={'name'}
    />
  )
}

export default Order
